export class Contact{
	name: string;
	email: string;
	cellPhone: string;
	phone: string;
}
